import PopoverDropdown from "../../../../elements/PopoverDropdown";
import { SketchPicker } from "react-color";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { rgba } from "../../../../../helpers";
import { setThemeValue } from "../../../../../redux/slice/themeSlice";

const SidebarMenuItemTool = ({ element }) => {
  const dispatch = useDispatch();
  const { theme, selectedElement } = useSelector((state) => state?.themeProvider);

  return (
    <div className="space-y-4">
      <div className="background-color">
        <div class="text-[14px] font-medium text-slate-600 mb-1  ">Background color</div>
        <PopoverDropdown
          buttonLabel={
            <div className="flex items-center space-x-2">
              {theme?.[element]?.backgroundColor && (
                <span
                  className="w-6 h-6 flex rounded"
                  style={{
                    backgroundColor: rgba(theme?.[element]?.backgroundColor),
                  }}></span>
              )}
              <span>Select colour</span>
            </div>
          }
          buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
          contentClass="border-0 p-0 !min-w-fit bg-transparent">
          <SketchPicker
            className="!shadow-none !border-0"
            color={theme?.[element]?.backgroundColor}
            onChange={(e) => {
              dispatch(
                setThemeValue({
                  [element]: { ...theme?.[element], backgroundColor: e.rgb },
                })
              );
            }}
          />
        </PopoverDropdown>
      </div>
      <div className="background-color-hover">
        <div class="text-[14px] font-medium text-slate-600 mb-1  ">Background color on hover</div>
        <PopoverDropdown
          buttonLabel={
            <div className="flex items-center space-x-2">
              {theme?.[element]?.backgroundColorHover && (
                <span
                  className="w-6 h-6 flex rounded"
                  style={{
                    backgroundColor: rgba(theme?.[element]?.backgroundColorHover),
                  }}></span>
              )}
              <span>Select colour</span>
            </div>
          }
          buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
          contentClass="border-0 p-0 !min-w-fit bg-transparent">
          <SketchPicker
            className="!shadow-none !border-0"
            color={theme?.[element]?.backgroundColorHover}
            onChange={(e) => {
              dispatch(
                setThemeValue({
                  [element]: {
                    ...theme?.[element],
                    backgroundColorHover: e.rgb,
                  },
                })
              );
            }}
          />
        </PopoverDropdown>
      </div>
      <div className="text-color">
        <div class="text-[14px] font-medium text-slate-600 mb-1  ">Text color</div>
        <PopoverDropdown
          buttonLabel={
            <div className="flex items-center space-x-2">
              {theme?.[element]?.color && (
                <span
                  className="w-6 h-6 flex rounded"
                  style={{
                    backgroundColor: rgba(theme?.[element]?.color),
                  }}></span>
              )}
              <span>Select colour</span>
            </div>
          }
          buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
          contentClass="border-0 p-0 !min-w-fit bg-transparent">
          <SketchPicker
            className="!shadow-none !border-0"
            color={theme?.[element]?.color}
            onChange={(e) => {
              dispatch(
                setThemeValue({
                  [element]: { ...theme?.[element], color: e.rgb },
                })
              );
            }}
          />
        </PopoverDropdown>
      </div>
      <div className="text-color-hover">
        <div class="text-[14px] font-medium text-slate-600 mb-1  ">Text color on hover</div>
        <PopoverDropdown
          buttonLabel={
            <div className="flex items-center space-x-2">
              {theme?.[element]?.colorHover && (
                <span
                  className="w-6 h-6 flex rounded"
                  style={{
                    backgroundColor: rgba(theme?.[element]?.colorHover),
                  }}></span>
              )}
              <span>Select colour</span>
            </div>
          }
          buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
          contentClass="border-0 p-0 !min-w-fit bg-transparent">
          <SketchPicker
            className="!shadow-none !border-0"
            color={theme?.[element]?.colorHover}
            onChange={(e) => {
              dispatch(
                setThemeValue({
                  [element]: { ...theme?.[element], colorHover: e.rgb },
                })
              );
            }}
          />
        </PopoverDropdown>
      </div>
      <div className="icon-color">
        <div class="text-[14px] font-medium text-slate-600 mb-1  ">Icon color</div>
        <PopoverDropdown
          buttonLabel={
            <div className="flex items-center space-x-2">
              {theme?.[element]?.iconColor && (
                <span
                  className="w-6 h-6 flex rounded"
                  style={{
                    backgroundColor: rgba(theme?.[element]?.iconColor),
                  }}></span>
              )}
              <span>Select colour</span>
            </div>
          }
          buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
          contentClass="border-0 p-0 !min-w-fit bg-transparent">
          <SketchPicker
            className="!shadow-none !border-0"
            color={theme?.[element]?.iconColor}
            onChange={(e) => {
              dispatch(
                setThemeValue({
                  [element]: { ...theme?.[element], iconColor: e.rgb },
                })
              );
            }}
          />
        </PopoverDropdown>
      </div>
      <div className="icon-color-hover">
        <div class="text-[14px] font-medium text-slate-600 mb-1  ">Icon color on hover</div>
        <PopoverDropdown
          buttonLabel={
            <div className="flex items-center space-x-2">
              {theme?.[element]?.iconColorHover && (
                <span
                  className="w-6 h-6 flex rounded"
                  style={{
                    backgroundColor: rgba(theme?.[element]?.iconColorHover),
                  }}></span>
              )}
              <span>Select colour</span>
            </div>
          }
          buttonClass="w-full bg-gray-100 border border-transparent hover:border hover:border-gray-400 hover:bg-gray-200 text-start text-gray-500 text-sm"
          contentClass="border-0 p-0 !min-w-fit bg-transparent">
          <SketchPicker
            className="!shadow-none !border-0"
            color={theme?.[element]?.iconColorHover}
            onChange={(e) => {
              dispatch(
                setThemeValue({
                  [element]: { ...theme?.[element], iconColorHover: e.rgb },
                })
              );
            }}
          />
        </PopoverDropdown>
      </div>
    </div>
  );
};

export default SidebarMenuItemTool;
